export default __webpack_public_path__ + "static/media/image-5.9fcdb486.gif";